<template>
  <div>
    <b-container fluid="xl">
      <b-row class="justify-content-end">
        <b-col
          md="6"
          cols="10"
          class="overflow-hidden vh-100 d-none d-md-block mr-auto bg-login"
        >
          <img :src="`${publicPath}/img/gep/img-login.svg`" class="img-login" />
          <div class="top-text">
            <div class="fz-28 fw-700">
              {{ $t("Welcome to RCPAY Virtual Account") }}
            </div>
            <div class="fz-28 fw-700">
              {{ $t("Simplifying Your Banking Experience") }}
            </div>
            <!-- <div class="fz-16 fw-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> -->
          </div>
          <div class="bottom-text">
            <!-- <div class="fz-31 fw-700">Welcome to<br />RC365 V Bank</div> -->
            <div class="fz-10 fw-400 mb-1">
              RCPAY Limited is incorporated in the United Kingdom with company
              registration number 12026575.
            </div>
            <div class="fz-10 fw-400">
              RCPAY Limited is the FCA regulated licensed company with license
              number: 917656
            </div>
          </div>
        </b-col>
        <b-col md="4" cols="10" class="minh-100 px-0 mx-auto">
          <div class="d-flex flex-column h-100 justify-content-center">
            <div class="mb-3">
              <div class="mb-1 fz-31 fw-700">{{ $t("Welcome!") }}</div>
              <div class="text-muted fz-16 fw-400">
                {{ $t("please login to access the system") }}.
              </div>
            </div>
            <!-- <hr/> -->
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form
                role="form"
                @submit.prevent="handleSubmit(onSubmit)"
                id="formLogin"
              >
                <div class="input-group input-group-alternative mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <img :src="`${publicPath}/img/rcp/icon/mdi_user.png`" />
                    </div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="username"
                    name="Username"
                    id="username"
                    :placeholder="$t('Username')"
                    @keydown="onChange('username')"
                    v-uppercase
                  />
                  <div
                    v-if="error.username"
                    class="invalid-feedback d-block mb-3"
                  >
                    {{ $t(error.username) }}
                  </div>
                </div>
                <div class="mb-3">
                  <base-input
                    alternative
                    class="mb-0"
                    id="Password"
                    name="Password"
                    prepend-icon="ni ni-lock-circle-open"
                    :type="show_password ? 'text' : 'password'"
                    :placeholder="$t('Password')"
                    v-model="password"
                    @keydown="onChange"
                  >
                    <template v-slot:prepend
                      ><img
                        :src="`${publicPath}/img/rcp/icon/mdi_password.png`"
                    /></template>
                    <template v-slot:append>
                      <a
                        class="btn-action"
                        @click.prevent="toggleShow('password')"
                      >
                        <i
                          class="far pl-2 pr-2"
                          :class="{
                            'fa-eye-slash': show_password,
                            'fa-eye': !show_password,
                          }"
                        ></i>
                      </a>
                    </template>
                  </base-input>
                  <div
                    v-if="error.password"
                    class="invalid-feedback d-block mb-3"
                  >
                    {{ $t(error.password) }}
                  </div>
                </div>

                <div class="text-right mb-2">
                  <a
                    href="#"
                    @click.prevent="gotoForgot"
                    class="fz-14 fw-400 text-primary"
                    >{{ $t("Forget Password?") }}</a
                  >
                </div>

                <div class="text-center">
                  <base-button
                    type="primary"
                    pill
                    native-type="submit"
                    class="my-4 fz-19 fw-600"
                    >{{ $t("Sign in") }}</base-button
                  >
                </div>
              </b-form>
            </validation-observer>
            <div v-if="isAllowRegis()" class="register-bottom fz-14 fw-400">
              <div
                v-if="!complete_regis || complete_regis != 'complete'"
                class="mb-4"
              >
                {{ $t("Do not have an account?") }}
                <a href="#" @click.prevent="gotoRegister" class="fz-14 fw-600"
                  >{{ $t("Join Us Now") }}!</a
                >
              </div>
              <div
                v-if="complete_regis == 'complete'"
                class="mb-4 complete-regis"
              >
                <span class="text-grey2 mr-2">{{
                  $t("Didn't receive the email ? ")
                }}</span>
                <a
                  href="#"
                  @click.prevent="gotoResendEmail"
                  class="fz-14 fw-600 text-blue2"
                  >{{ $t("Resend email") }}</a
                >
              </div>
            </div>

            <a
              v-if="isShowWaLink()"
              href="https://api.whatsapp.com/send/?phone=60108929399"
              target="_blank"
              class="position-absolute bottom-0 right-0 mr-5"
            >
              <img :src="`${publicPath}/img/rcp/-wa.png`" width="40" />
            </a>
            <div
              v-if="translation == 1"
              class="change_lang pb-4 px-4 pt-2 text-center"
              id="language"
            >
              <span
                v-for="(item, index) in language_list"
                v-if="index != 'my-MY'"
                :key="index"
              >
                <a
                  @click.stop.prevent="setLanguage(index)"
                  :class="'fz-14 ' + (current_lang == index ? 'active' : '')"
                  >{{ item }}</a
                >
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <PopupConfirmation
      :token="this.$route.query.verification"
      @token-verified="isLoading = false"
    ></PopupConfirmation>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import Auth from "@/services/Auth";
import Common from "@/services/Common";
import PopupConfirmation from "@/components/PopupConfirmation";
import LoaderComponent from "@/components/LoaderComponent";

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      translation: process.env.VUE_APP_TRANSLATION,
      domain: process.env.VUE_APP_DOMAIN,
      wa_link: JSON.parse(process.env.VUE_APP_WALINK),
      company_logo: "",
      list_logo: JSON.parse(process.env.VUE_APP_COMPANY_LOGO),
      register: JSON.parse(process.env.VUE_APP_REGISTER),
      complete_regis: "",
      username: "",
      password: "",
      show_password: false,
      isLoading: false,
      current_lang: "",
      language_list: [],
      error: {
        username: "",
        password: "",
      },
    };
  },
  components: { PopupConfirmation, LoaderComponent },
  methods: {
    isAllowRegis() {
      let check = true;
      Object.keys(this.register).forEach((key) => {
        if (
          window.location.hostname.indexOf(key) != -1 &&
          this.register[key] == 0
        ) {
          check = false;
        }
      });

      return check;
    },
    isShowWaLink() {
      let check = false;
      Object.keys(this.wa_link).forEach((key) => {
        if (
          window.location.hostname.indexOf(key) != -1 &&
          this.wa_link[key] == 1
        ) {
          check = true;
        }
      });

      return check;
    },
    setLanguage(param) {
      localStorage.setItem("lang", param);
      localStorage.setItem("lang-key", param);
      const self = this;
      self.$notify({
        type: "success",
        text: self.getMessage("Successfully change default language"),
      });

      setTimeout(function () {
        location.reload();
      }, 500);
    },
    getMessage: function (key) {
      return this.$t(key);
    },
    toggleShow(name) {
      this["show_" + name] = !this["show_" + name];
    },
    gotoResendEmail() {
      this.$router.push({ path: "/resend-email" });
    },
    gotoForgot: function () {
      this.$router.push({ path: "/forgot-password" });
    },
    gotoRegister: function () {
      this.$router.push({ path: "/register" });
    },
    onChange: function () {
      Object.keys(this.error).forEach((key) => {
        this.error[key] = "";
      });
    },
    iframeEvent: function (e) {
      if (e.data && (typeof e.data === "string" || e.data instanceof String)) {
        const data = JSON.parse(e.data);
        this.afterLogin(data);
      }
    },
    inIframe: function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    afterLogin: function (data) {
      const self = this;
      localStorage.setItem("isFirstTime", data.status_login);
      localStorage.setItem("member", btoa(data.id));
      localStorage.setItem("token", data.token);
      localStorage.setItem("init", true);

      this.isLoading = false;

      if (this.translation == 1) {
        Common.profile().then((response) => {
          if (response.status == 200 && response.data.success) {
            const profile = response.data.data;
            if (profile.language && profile.language != null) {
              localStorage.setItem("lang", profile.language);
              localStorage.setItem("lang-key", profile.language);
              this.$i18n.locale = profile.language;
            }
            if (this.domain == 1) {
              window.parent.location.href = data.domain;
            } else {
              const link = localStorage.getItem("link");
              if (link && link.indexOf(data.domain)) {
                window.parent.location.href = link;
              } else {
                this.$router.push({ path: "/" });
              }
            }
          }
        });
      } else if (this.domain == 1) {
        window.parent.location.href = data.domain;
      } else {
        const link = localStorage.getItem("link");
        if (link && link.indexOf(data.domain)) {
          window.parent.location.href = link;
        } else {
          this.$router.push({ path: "/" });
        }
      }
    },
    onSubmit: async function () {
      this.isLoading = true;
      const data = { username: this.username, password: this.password };

      await Auth.login(data)
        .then((response) => {
          if (response.status == 200 && response.data.success) {
            const data = response.data;
            const isFirstTime =
              data.status_login &&
              (data.status_login == "first_login" ||
                data.status_login == "forget-password")
                ? data.status_login
                : false;

            if (data.domain && this.domain == 1) {
              const url =
                data.domain.indexOf("https") == -1 ||
                data.domain.indexOf("http") == -1
                  ? "https://" + data.domain
                  : data.domain;

              if (data.domain.indexOf(window.location.hostname) == -1) {
                let iframe = document.createElement("iframe");
                iframe.onload = function () {
                  const wind = iframe.contentWindow;
                  const post = {
                    status_login: isFirstTime,
                    domain: url,
                    id: data.id,
                    token: data.token,
                  };
                  wind.postMessage(JSON.stringify(post), "*");
                };
                iframe.src =
                  url + "/login?rand=" + Math.round(Math.random() * 10000000);
                document.body.appendChild(iframe);
              } else {
                data.status_login = isFirstTime;
                this.afterLogin(data);
              }
            } else {
              data.status_login = isFirstTime;
              this.afterLogin(data);
            }
          } else {
            this.isLoading = false;
            this.$notify({ type: "error", text: response.data.message });
          }
        })
        .catch((err) => {
          this.isLoading = false;
          const response = err.response;

          if (typeof err === "string" || err instanceof String) {
            this.$notify({
              type: "error",
              text: "Oppss.. Something wrong, please contact admin",
            });
          } else if (response.status == 400) {
            if (response.data.data) {
              Object.keys(response.data.data).forEach((key) => {
                this.error[key] = response.data.data[key][0];
              });
            } else {
              this.error.password = response.data.message;
            }
          } else {
            this.error.password = err.message;
          }
        });
    },
  },
  mounted() {
    this.complete_regis = this.$route.query.register;

    if (this.$route.query.verification) {
      this.isLoading = true;
    }

    Object.keys(this.list_logo).forEach((key) => {
      if (window.location.hostname.indexOf(key) != -1) {
        this.company_logo = this.list_logo[key];
      }
    });
    if (this.domain == 1) {
      window.addEventListener("message", this.iframeEvent, false);
    }

    if (this.translation == 1) {
      this.current_lang = localStorage.getItem("lang-key");
      Common.get_language().then((response) => {
        if (response.status == 200 && response.data.success) {
          this.language_list = response.data.data;
        }
      });
    }
  },
};
</script>

<style>
.complete-regis {
  display: flex;
  align-items: center;
  justify-content: center;
}
.complete-regis::before,
.complete-regis::after {
  content: " ";
  height: 1px;
  width: 53px;
  background: #d9d9d9;
  margin-left: 28px;
  margin-right: 28px;
}
.register-bottom a.text-blue2 {
  color: #0972d3 !important;
}
</style>
